import { fa } from '../i18n/fa';

export default function SourcesPanel({ sources }) {
  if (sources.length === 0) {
    return (
      <div className="tr-card tr-panel">
        <h2 className="tr-title">{fa.charts.sources.title}</h2>
        <p className="tr-sub tr-empty-inline">{fa.empty.sources}</p>
      </div>
    );
  }
  return (
    <div className="tr-card tr-panel">
      <h2 className="tr-title">{fa.charts.sources.title}</h2>
      {sources.map((s) => (
        <div className="tr-src" key={s.name}>
          <span>
            <i
              className="tr-dot"
              style={{ background: s.ok ? 'var(--green)' : 'var(--red)' }}
              aria-hidden="true"
            />
            {fa.sourceName(s.name)}
          </span>
          <span className="tr-sub">
            {s.ok ? fa.charts.sources.fresh(s.hours_ago) : fa.charts.sources.stale(s.hours_ago)}
          </span>
        </div>
      ))}
    </div>
  );
}
